import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Splash from './pages/splash';
import Onboarding1 from './pages/onboarding1';
import Onboarding2 from './pages/onboarding2';
import Onboarding3 from './pages/onboarding3';
import Login from './pages/login';
import Signup from './pages/signup';
import Home from './pages/home';
import Myticket from './pages/myticket';
import Map from './pages/map';
import Notifications from './pages/notifications';
import Booking from './pages/booking';
import Error from './pages/error';
import Eventdetails from './pages/event-details';
import Booking2 from './pages/booking-page2';
import Bookingp3 from './pages/booking-page3';
const Paths = () => {
    return (
     <BrowserRouter>
                <Routes>
                <Route path='/'  element={<Splash />} /> 
                <Route path='/onboarding-page1'  element={<Onboarding1 />}  /> 
                 <Route path='/onboarding-page2'  element={<Onboarding2 />  }  />          
                 <Route path='/onboarding-page3'  element={<Onboarding3 />  }  />                    
                <Route path='/login'  element={ <Login />  }  />                
                <Route path='/signup'  element={ <Signup />  }  />   
                <Route path='/home'  element={ <Home /> }  />    
                <Route path='/my-ticket'  element={ <Myticket />   }  />   
                <Route path='/map'  element={  <Map />   }  />  
                <Route path='/notification'  element={  <Notifications />    }  />       
                 <Route path='/booking'  element={ <Booking />     }  />  
                 <Route path='/booking-summary'  element={ <Booking2 />     }  />  
                 <Route path='/booking-card-pay'  element={ <Bookingp3 />     }  />  
                <Route path='/error'  element={ <Error /> }  />    
                <Route path='/eventdetails'  element={ <Eventdetails /> }  />    
                </Routes>
    </BrowserRouter>
      );
}
 
export default Paths;